export const DEFAULT_LANGUAGE = 'da';
export const DEFAULT_MARKET = 'dk';
